<template lang="pug">
  include ./../../vuek/mixins.pug

  +b.the-rating-section
    t-section
      t-h2 {{content.header1}}
      t-h3 {{content.subHeader1}}
      +e.rating
        t-rating(
          :dataSet="dataSet"
          :filterFunction="filterFunction"
          :selectedСountries="selectedСountries"
          :margin="margin"
        )
      +e.controls
        +e.btn(@click="filter = null" :class="{'is-active' : filter == null}") {{content.btn1}}
        +e.btn(@click="filter = 1" :class="{'is-active' : filter == 1}") {{content.btn2}}
        +e.btn(@click="filter = 2" :class="{'is-active' : filter == 2}") {{content.btn3}}
        +e.btn(@click="filter = 3" :class="{'is-active' : filter == 3}") {{content.btn4}}
        +e.btn(@click="filter = 4" :class="{'is-active' : filter == 4}") {{content.btn5}}
        +e.btn(@click="filter = 5" :class="{'is-active' : filter == 5}") {{content.btn6}}
        +e.btn(@click="filter = 6" :class="{'is-active' : filter == 6}") {{content.btn7}}
        +e.btn(@click="filter = 7" :class="{'is-active' : filter == 7}") {{content.btn8}}
        +e.btn(@click="filter = 8" :class="{'is-active' : filter == 8}") {{content.btn9}}
        +e.btn(@click="filter = 9" :class="{'is-active' : filter == 9}") {{content.btn10}}
        //- +e.btn(@click="filter = 10" :class="{'is-active' : filter == 10}") Європейський союз
        +e.btn(@click="filter = 11" :class="{'is-active' : filter == 11}") {{content.btn11}}
</template>

<script>
import { mapGetters } from 'vuex';

import TSection from '@/components/TSection/TSection';
import TH2 from '@/components/TH2/TH2';
import TH3 from '@/components/TH3/TH3';
import TRating from '@/components/TRating/TRating';

export default {
  name: 'the-rating-section',

  data() {
    return {
      filter: null,

      margin: {
        left: 64,
        right: 64,
        top: 0,
        bottom: 0,
      },

      // Страны которые нужно выделить
      selectedСountries: [
        {
          ISO3: 'DNK',
          height: 0.9,
        },
        {
          ISO3: 'SOM',
          height: 0.9,
        },
        {
          ISO3: 'ROU',
          height: 0.9,
        },
        {
          ISO3: 'MDA',
          height: 0.8,
        },
        {
          ISO3: 'HUN',
          height: 0.75,
        },
        {
          ISO3: 'SVK',
          height: 0.85,
        },
        {
          ISO3: 'POL',
          height: 0.8,
        },
        {
          ISO3: 'BLR',
          height: 0.6,
        },
        {
          ISO3: 'GEO',
          height: 0.6,
        },
        {
          ISO3: 'TUR',
          height: 0.9,
        },
        {
          ISO3: 'RUS',
          height: 0.83,
        },
        {
          ISO3: 'UKR',
          height: 0.7,
        },
      ],
    };
  },

  computed: {
    filterFunction() {
      let result = null;

      switch (this.filter) {
        case 1:
          result = item => item.region.includes('AME');
          break;
        case 2:
          result = item => item.region.includes('AP');
          break;
        case 3:
          result = item => item.region.includes('MENA');
          break;
        case 4:
          result = item => item.region.includes('SSA');
          break;
        case 5:
          result = item => item.region.includes('WE/EU');
          break;
        case 6:
          result = item => item.region.includes('ECA');
          break;
        case 7:
          result = item => item.region.includes('OECD');
          break;
        case 8:
          result = item => item.region.includes('G20');
          break;
        case 9:
          result = item => item.region.includes('BRICS');
          break;
        // case 10:
        //   result = item => item.region.includes('EU');
        //   break;
        case 11:
          result = item => item.region.includes('AS');
          break;
        default:
          result = null;
      }

      return result;
    },

    ...mapGetters({
      dataSet: 'allDataSet',
      content: 'getContent',
    }),
  },

  components: {
    TSection,
    TH2,
    TH3,
    TRating,
  },
};
</script>


<style lang="scss">
@import '../../scss/styles';

.the-rating-section {
  position: relative;
  width: 100%;
  overflow: auto;

  &__rating {
    width: 100%;
    height: 60vh;
  }

  &__controls {
    display: block;
    text-align: center;
    margin: 0 16px;
  }

  &__btn {
    display: inline-block;
    border: 1px solid $color-blue;
    color: white;
    font-size: 12px;
    line-height: 12px;
    // text-transform: uppercase;
    border-radius: 10px;
    padding-top: 5px;
    padding-bottom: 3px;
    padding-left: 12px;
    padding-right: 12px;
    font-weight: 900;
    font-family: $hfont;
    cursor: pointer;
    margin-right: 16px;
    opacity: 1;
    transition: all 0.3s;
    margin-bottom: 12px;

    &:hover {
      opacity: 0.8;
    }

    &.is-active {
      background-color: $color-blue;
    }
  }

  &__controls &__btn:last-of-type {
    margin-right: 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TheRatingSection/TheRatingSection.vue